<iot-platform-ui-subscription-button (click)="onDispatchEvent($event)" [isCurrentUserSubscribed]="subscribed()" />
